import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { ConnectService } from '../services/connect/connect.service';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class ShortURLGuard implements CanActivate {
  private router = inject(Router);
  private connect = inject(ConnectService);

  canActivate(route: ActivatedRouteSnapshot) {
    return this.connect.getCustom(`/accounts/expand_url?short_key=${route.params.code}`).pipe(
      map((res: { url: string }) => {
        return this.router.parseUrl(res.url.replace(/^https?:\/\/[^/]+/, ''));
      }),
      catchError(error => {
        if (error instanceof HttpErrorResponse) {
          if (error.status >= 500) return of(this.router.parseUrl(`/error/${error.status}`));
        }
        return of(true);
      })
    );
  }
}
